import React from "react";

const FourOFour = () => {
  return <div>FourOFour</div>;
};

export default FourOFour;
